<template>
  <v-card-text class="item-details d-flex">
    <div class="pr-4">
      <v-img
        :src="item.imageUrl"
        width="80"
        contain
      />
    </div>
    <div>
      <p class="brand-name">
        <span>{{ item.brandName }}</span>
        <span
          v-if="showLast4"
          id="payment-last-four"
        >
          {{ paymentLast4 }}
        </span>
      </p>
      <p class="total">
        {{ $money(item.lineItemTotal, item.currencyCode) }}
        <span
          v-if="item.isUnsuccessful"
          class="error--text"
        >
          {{ $t('redemption-history-refunded') }}
        </span>
      </p>
      <p
        v-if="!hideDate"
        class="created-date"
      >
        {{ dateLabel }}
      </p>
    </div>
  </v-card-text>
</template>

<script>
import { RedeemedItem } from '@/store/classes/redeemed-item'
import { PAYMENT_REWARD_TYPES } from '@/components/shared/item/reward-type-constants'

export default {
  name: 'RedeemedItemDetails',
  props: {
    item: {
      type: RedeemedItem,
      required: true
    },
    hideDate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedDate () {
      return new Date(this.item.createdAt).toLocaleDateString(undefined, {
        month: 'short',
        year: 'numeric',
        day: '2-digit'
      })
    },
    dateLabel () {
      if (this.isPaymentRewardType) {
        return (
          this.$t('redemption-history-transaction-label') +
          ' ' +
          this.formattedDate
        )
      } else {
        return (
          this.$t('redemption-history-date-label') + ' ' + this.formattedDate
        )
      }
    },
    paymentLast4 () {
      return this.item.directPaymentMetadata?.last4 ? '- ' + this.item.directPaymentMetadata.last4 : ''
    },
    showLast4 () {
      return this.isPaymentRewardType && !!this.paymentLast4
    },
    isPaymentRewardType () {
      return PAYMENT_REWARD_TYPES.includes(this.item.rewardType)
    }
  }
}
</script>

<style scoped lang="scss">
.item-details {
  font-size: 1rem;
  p {
    margin-bottom: 0.25rem;
  }
}
</style>
